import globals from './lib/globals';
import Player from '@vimeo/player';
import ThemeFlexibleContent from './partials/themeFlexibleContent';
import Logger from "./utilities/Logger";

// Bootstrap global functionality
globals();

const NAME = 'HOME';

// Get the hero videos (and images)
const homeVars = window.home_vars;
const heroVideos = homeVars?.hero_videos;
const heroVideosJson = JSON.parse(heroVideos);

// Initialize the Video Player
let videoPlayer;
const videoContainer = document.querySelector('[data-hero-video]');
const videoContainerLoadedClass = 'home-hero__video--loaded';
const videoIds = heroVideosJson.map((item) => { return item.vimeo_id; });
const videoPlaceholderContainer = document.querySelector('[data-hero-video-placeholder]');
const videoPlaceholderHiddenClass = 'home-hero__video-placeholder--hidden';
const videoPlaceholderImages = heroVideosJson.map((item) => { return item.image; });
const videoMuteButton = document.querySelector('.home-hero__video-mute');
let currentVideo = 0;

/**
 * Load a new video
 **/
const loadVideo = (videoId, forcePause) => {
  Logger.info(`Loading new video: ${videoId}`);
  videoPlayer.loadVideo(videoId).then(function(id) {
    Logger.info('Video loaded...');
    if(forcePause) {
      videoPlayer.pause();
    }
  }).catch(function(error) {
    Logger.error(error);
  });
  videoPlayer.setLoop(false);
}

const setVideoPlaceholderImage = (src) => {
  videoPlaceholderContainer.style.backgroundImage = `url('${src}')`;
}

/**
 * Init the hero video player
 **/
const initializeHeroVideo = () => {

  if(!videoIds || !videoIds.length) {
    return;
  }

  const videoId = videoIds[currentVideo];
  const placeholderImage = videoPlaceholderImages[currentVideo];

  if(!videoId) {
    return;
  }

  if(!videoPlayer && videoId) {

    Logger.info('Initializing hero video...');

    const videoPlayerPlayAction = videoContainer.querySelector('[data-hero-video-play-action]');
    const videoPlayerPlayActionHiddenClass = 'home-hero__video-play-action--hidden';
    
    if(videoPlayerPlayAction) {
        videoPlayerPlayAction.addEventListener('click', async (e) => {
            e.preventDefault();
            const isPaused = await videoPlayer.getPaused();
            if(isPaused) {
              await videoPlayer.setMuted(false);
              videoPlayer.play();
            } else {
              videoPlayer.pause();
            }
        });
    }

    const options = {
      id: videoId,
      autoplay: false,
      controls: false,
      keyboard: false,
      responsive: true,
      muted: true,
      width: 640,
      loop: false
    };

    videoPlayer = new Player(videoContainer, options);

    videoMuteButton.addEventListener('click', async () => {
      const isMuted = await videoPlayer.getMuted();
      await videoPlayer.setMuted(!isMuted);
      if (isMuted) {
        videoMuteButton.classList.remove('home-hero__video-muted');
      } else {
        videoMuteButton.classList.add('home-hero__video-muted');
      }
    });

    videoPlayer.on('ended', async () => {
      Logger.info('Video has ended...');
      currentVideo++;
      if(videoPlaceholderImages[currentVideo]) {
        setVideoPlaceholderImage(videoPlaceholderImages[currentVideo]);
      }
      if(videoIds[currentVideo]) {
        loadVideo(videoIds[currentVideo], true);
      }
      videoPlaceholderContainer.classList.remove(videoPlaceholderHiddenClass);
      videoPlayerPlayAction.classList.remove(videoPlayerPlayActionHiddenClass);
    });

    videoPlayer.on('loaded', function() {
      Logger.info('New video was loaded...');
      videoContainer.classList.add(videoContainerLoadedClass);
    });

    videoPlayer.on('playing', function() {
      Logger.info('Video is playing...');
      videoPlaceholderContainer.classList.add(videoPlaceholderHiddenClass);
      videoPlayerPlayAction.classList.add(videoPlayerPlayActionHiddenClass);
    });

    videoPlayer.on('pause', function() {
      Logger.info('Video is paused...');
      videoPlaceholderContainer.classList.remove(videoPlaceholderHiddenClass);
      videoPlayerPlayAction.classList.remove(videoPlayerPlayActionHiddenClass);
    });

    setVideoPlaceholderImage(placeholderImage);
    loadVideo(videoId, true);
  }
}

// Create an Observer
// We only want to initialize the video player when it's actually visible
// on the page.
const videoObserver = new IntersectionObserver((entries) => {

  // Check for the intersecting item
  entries.forEach( (entry, index) => {
    if(entry.isIntersecting) {

      entry.target.setAttribute('data-is-visible',true);
        // console.info('Home Hero Video: focused...');
        initializeHeroVideo();

    } else {

      entry.target.removeAttribute('data-is-visible',true);
        // console.info('Home Hero Video: blurred...');

    }

  });

}, {
  threshold: .01,
});

videoObserver.observe(videoContainer);


// Initialize the Flexible Content sections

// Gather all themeFlexibleContents
const themeFlexibleContents = document.querySelectorAll('[data-theme-flexible-content]');
themeFlexibleContents.forEach((dom) => {
    const themeFlexibleContent = new ThemeFlexibleContent(
        dom
    );
});

Logger.log(`${NAME} > init.✨`);
